export class DashboardInformation {
  dashboardWelcomeText: string;
  dashboardUsername: string;
  loggedInUser: LoggedInUser;

  constructor(dashboardWelcomeText: string, dashboardUsername: string, loggedInUser: LoggedInUser) {
    this.dashboardWelcomeText = dashboardWelcomeText;
    this.dashboardUsername = dashboardUsername;
    this.loggedInUser = loggedInUser;
  }

}

export class LoggedInUser {
  AffiliationId: Number;
  BackPageUrl: string;
  BatchId: Number;
  CurrentScreenId: Number;
  DisplayTitle: string;
  EmployeeJobTitleId: Number;
  HomePageUrl: string;
  // IsEmployeePortal { get; set; }
  LocationId: Number;
  LocationName: string;
  LoginTitle: string;
  MenuId: Number;
  OrgId: Number;
  PageName: string;
  RoleId: Number;
  ScreenID: Number;
  SessionId: string;
  StoreLocationId: Number;
  StoreLocationName: string;
  UserFullName: string;
  UserId: Number;
  // byte[] UserPhoto { get; set; }
  UserSourceId: Number;
  UserSourceTypeId: Number;

  //newly added properties
  //EmployeeCommunication
  MobileNumber: string;
  PersonalEmail: string;
  EmergencyContactNo: string;
  //EmployeePersonalDetails
  GenderId: string;
  Gender: string;
  // DateTime DateOfBirth { get; set; }
  BloodGroupId: Number;
  BloodGroup: string;
  MaritalStatusId: Number;
  MaritalStatus: string;
}